var React = require('react');

function Padlock (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"15","cy":"15","fill":"#c4bfb6","opacity":".2","r":"15","key":0}),React.createElement("path",{"d":"m19.5 11.3333333h-.75v-1.52380949c0-2.10285714-1.68-3.80952381-3.75-3.80952381s-3.75 1.70666667-3.75 3.80952381v1.52380949h-.75c-.825 0-1.5.6857143-1.5 1.5238096v7.6190476c0 .8380952.675 1.5238095 1.5 1.5238095h9c.825 0 1.5-.6857143 1.5-1.5238095v-7.6190476c0-.8380953-.675-1.5238096-1.5-1.5238096zm-2.175 0h-4.65v-1.52380949c0-1.30285714 1.0425-2.36190476 2.325-2.36190476s2.325 1.05904762 2.325 2.36190476z","fill":"#65686b","fillRule":"nonzero","key":1})]));
}

Padlock.defaultProps = {"height":"30","viewBox":"0 0 30 30","width":"30"};

module.exports = Padlock;

Padlock.default = Padlock;
